export const ENTITY_FORM_GRID_DATA_IDS = {
  base: 'entity-form-grid',
  container: 'container',
  title: 'title',
  subtitle: 'subtitle',
  toggle: 'toggle',
  fields: 'fields',
  fieldContainerL1: 'field-container-l1',
  fieldContainerL2: 'field-container-l2'
};
